import { useMutation, useQueryClient } from 'react-query';

import { apiClient } from 'src/services/api/client';
import { queryKeys } from 'src/services/api/constants';

export const useMarkListingRead = () => {
    const queryClient = useQueryClient();

    return useMutation(async (notificationId: number) => {
        await apiClient(`api/landlord/notifications/${notificationId}/read`, {
            method: 'put',
        }).json();
    }, {
        onSuccess: () => {
            queryClient.invalidateQueries(queryKeys.listings);
        },
    });
};
